module.exports = __webpack_public_path__ + "assets/img/fazhan2.e8d599e3.jpg";